<template>
    <sa-page-layout class="sa-no-space" btnRouterBackVisible btnRefreshVisible @refresh="onReloadDati">
        <template slot="toolbar">
        </template>
        <template slot="table-body">
            <SiatPraticheEditComponent style="overflow: scroll;" ref="cmpSiatPraticheEditComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin.js";
import SiatPraticheEditComponent from "../components/SiatPraticheEditComponent.vue"

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, SiatPraticheEditComponent },
    data() {
        return {
            pathResource: "/siatpratiche",
            id: null,
        };
    },
    mounted() {
        this.id = this.$route.params.id;

    },
    watch: {

    },
    methods: {
        onReloadDati() {
            this.$refs.cmpSiatPraticheEditComponent.loadData();
        }
    },
};
</script>
